import './index.less';
import VideoPlayer from './VideoPlayer';

VideoPlayer.install = function(Vue) {
  Vue.component(VideoPlayer.name, VideoPlayer);
};

export default VideoPlayer;
